import { filter, map, switchMap, take, tap } from 'rxjs/operators';
import { isObservable, from, of } from 'rxjs';
import { InjectionToken, Inject, Injectable, NgModule } from '@angular/core';
import { isFunction, isObject, isString, TRANSLOCO_LOADER } from '@ngneat/transloco';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/transloco-persist-translations.config.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
import * as ɵngcc0 from '@angular/core';
const defaultConfig = {
    ttl: 86400,
    // One day
    storageKey: '@transloco/translations',
    loader: null,
    storage: null
};
/** @type {?} */
const PERSIST_TRANSLATIONS_LOADER = new InjectionToken('PERSIST_TRANSLATIONS_LOADER');
/** @type {?} */
const PERSIST_TRANSLATIONS_STORAGE = new InjectionToken('PERSIST_TRANSLATIONS_STORAGE');
/** @type {?} */
const PERSIST_TRANSLATIONS_CONFIG = new InjectionToken('PERSIST_TRANSLATIONS_CONFIG');

/**
 * @fileoverview added by tsickle
 * Generated from: lib/transloco.storage.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/helpers.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} v
 * @return {?}
 */
function isPromise(v) {
    return v && isFunction(v.then);
}
/**
 * @template T
 * @param {?} asyncOrValue
 * @return {?}
 */
function observify(asyncOrValue) {
    if (isPromise(asyncOrValue) || isObservable(asyncOrValue)) {
        return from(asyncOrValue);
    }
    return of(asyncOrValue);
}
/**
 * @return {?}
 */
function now() {
    return new Date().getTime();
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/transloco-persist-translations.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const getTimestampKey = (/**
 * @param {?} key
 * @return {?}
 */
key => `${key}/timestamp`);
class TranslocoPersistTranslations {
    /**
     * @param {?} loader
     * @param {?} storage
     * @param {?} config
     */
    constructor(loader, storage, config) {
        this.loader = loader;
        this.storage = storage;
        this.config = config;
        this.cache = null;
        this.merged = Object.assign({}, defaultConfig, (config || {}));
        this.subscription = this.clearCurrentStorage().subscribe();
    }
    /**
     * @param {?} lang
     * @return {?}
     */
    getTranslation(lang) {
        /** @type {?} */
        const storageKey = this.merged.storageKey;
        return this.getCached(storageKey).pipe(switchMap((/**
         * @param {?} translations
         * @return {?}
         */
        translations => {
            if (translations && translations[lang]) {
                return of(translations[lang]);
            }
            return from(this.loader.getTranslation(lang)).pipe(tap((/**
             * @param {?} translation
             * @return {?}
             */
            translation => this.setCache(storageKey, lang, translation))));
        })));
    }
    /**
     * @return {?}
     */
    clearCache() {
        this.clearTimestamp(this.merged.storageKey);
        this.clearTranslations();
        this.cache = null;
    }
    /**
     * @private
     * @param {?} key
     * @return {?}
     */
    getCached(key) {
        return this.cache
            ? of(this.cache)
            : observify(this.storage.getItem(key)).pipe(map((/**
             * @param {?} item
             * @return {?}
             */
            item => (item ? this.decode(key, item) : null))), tap((/**
             * @param {?} item
             * @return {?}
             */
            item => (this.cache = item))), take(1));
    }
    /**
     * @private
     * @param {?} key
     * @param {?} lang
     * @param {?} translation
     * @return {?}
     */
    setCache(key, lang, translation) {
        /** @type {?} */
        const translations = this.cache || {};
        translations[lang] = translation;
        this.setTimestamp(key);
        this.storage.setItem(key, this.encode(translations));
        this.cache = translations;
    }
    /**
     * @private
     * @param {?} value
     * @return {?}
     */
    encode(value) {
        return JSON.stringify(value);
    }
    /**
     * @private
     * @template T
     * @param {?} key
     * @param {?} item
     * @return {?}
     */
    decode(key, item) {
        if (isObject(item)) {
            return item;
        }
        else if (isString(item)) {
            try {
                return JSON.parse(item);
            }
            catch (e) {
                console.error(`storage key: ${key} is not serializable`);
                return null;
            }
        }
        return null;
    }
    /**
     * @private
     * @param {?} key
     * @return {?}
     */
    setTimestamp(key) {
        this.storage.setItem(getTimestampKey(key), now());
    }
    /**
     * @private
     * @param {?} key
     * @return {?}
     */
    getTimestamp(key) {
        return observify(this.storage.getItem(getTimestampKey(key))).pipe(map((/**
         * @param {?} time
         * @return {?}
         */
        (time) => parseInt(time))));
    }
    /**
     * @private
     * @param {?} key
     * @return {?}
     */
    clearTimestamp(key) {
        this.storage.removeItem(getTimestampKey(key));
    }
    /**
     * @private
     * @return {?}
     */
    clearTranslations() {
        this.storage.removeItem(this.merged.storageKey);
    }
    /**
     * @private
     * @return {?}
     */
    clearCurrentStorage() {
        /** @type {?} */
        const storageKey = this.merged.storageKey;
        return this.getTimestamp(storageKey)
            .pipe(filter((/**
         * @param {?} time
         * @return {?}
         */
        time => !!time)), tap((/**
         * @param {?} time
         * @return {?}
         */
        time => {
            /** @type {?} */
            const isExpired = now() - time >= this.merged.ttl;
            if (isExpired) {
                this.storage.removeItem(storageKey);
            }
        })));
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
TranslocoPersistTranslations.ɵfac = function TranslocoPersistTranslations_Factory(t) { return new (t || TranslocoPersistTranslations)(ɵngcc0.ɵɵinject(PERSIST_TRANSLATIONS_LOADER), ɵngcc0.ɵɵinject(PERSIST_TRANSLATIONS_STORAGE), ɵngcc0.ɵɵinject(PERSIST_TRANSLATIONS_CONFIG)); };
TranslocoPersistTranslations.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: TranslocoPersistTranslations, factory: TranslocoPersistTranslations.ɵfac });
/** @nocollapse */
TranslocoPersistTranslations.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [PERSIST_TRANSLATIONS_LOADER,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [PERSIST_TRANSLATIONS_STORAGE,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [PERSIST_TRANSLATIONS_CONFIG,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TranslocoPersistTranslations, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [PERSIST_TRANSLATIONS_LOADER]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [PERSIST_TRANSLATIONS_STORAGE]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [PERSIST_TRANSLATIONS_CONFIG]
            }] }]; }, null); })();

/**
 * @fileoverview added by tsickle
 * Generated from: lib/transloco-persist-translations.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class TranslocoPersistTranslationsModule {
    /**
     * @param {?} config
     * @return {?}
     */
    static init(config) {
        return {
            ngModule: TranslocoPersistTranslationsModule,
            providers: [
                { provide: PERSIST_TRANSLATIONS_CONFIG, useValue: config },
                { provide: PERSIST_TRANSLATIONS_LOADER, useClass: config.loader },
                { provide: TRANSLOCO_LOADER, useClass: TranslocoPersistTranslations },
                config.storage
            ]
        };
    }
}
TranslocoPersistTranslationsModule.ɵfac = function TranslocoPersistTranslationsModule_Factory(t) { return new (t || TranslocoPersistTranslationsModule)(); };
TranslocoPersistTranslationsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TranslocoPersistTranslationsModule });
TranslocoPersistTranslationsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TranslocoPersistTranslationsModule, [{
        type: NgModule
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: ngneat-transloco-persist-translations.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { defaultConfig, PERSIST_TRANSLATIONS_LOADER, PERSIST_TRANSLATIONS_STORAGE, PERSIST_TRANSLATIONS_CONFIG, TranslocoPersistTranslations, TranslocoPersistTranslationsModule };

//# sourceMappingURL=ngneat-transloco-persist-translations.js.map